import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-4'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mã nhóm</Label>
          <FormField type='text' name='ma_nhom' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Tên phân nhóm</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_phan_nhom' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Tên khác</Label>
          <div className='w-full'>
            <FormField type='text' name='ten2' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Trạng thái</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='trang_thai'
              disabled={formMode === 'view'}
              options={[
                { label: '1. Còn sử dụng', value: '1' },
                { label: '0. Không sử dụng', value: '0' }
              ]}
              defaultValue={'1'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
